import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "main-con"
};
const _hoisted_2 = {
  class: "shop-title"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  key: 3,
  class: "sms-con"
};
const _hoisted_6 = {
  key: 0,
  style: {
    "color": "red"
  }
};
const _hoisted_7 = {
  key: 1,
  style: {
    "color": "blue"
  }
};
const _hoisted_8 = {
  class: "label"
};
const _hoisted_9 = {
  style: {
    "display": "flex",
    "justify-content": "center",
    "margin": "10px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_header = _resolveComponent("app-header");
  const _component_van_image = _resolveComponent("van-image");
  const _component_Radio = _resolveComponent("Radio");
  const _component_RadioGroup = _resolveComponent("RadioGroup");
  const _component_cell_group = _resolveComponent("cell-group");
  const _component_Button = _resolveComponent("Button");
  const _component_Form = _resolveComponent("Form");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_app_header, {
    title: "营业厅素材"
  }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, _toDisplayString(_ctx.formData.shopName), 1), _createElementVNode("div", null, "运营位：" + _toDisplayString(_ctx.formData.posName), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posBizList, val => {
    return _openBlock(), _createElementBlock("div", {
      class: "assets",
      key: val.id
    }, [val.srcTyp === '1' ? (_openBlock(), _createBlock(_component_van_image, {
      key: 0,
      class: "assets-img",
      fit: "scale-down",
      src: val.srcOutUrl
    }, null, 8, ["src"])) : _createCommentVNode("", true), val.srcTyp === '2' ? (_openBlock(), _createElementBlock("audio", {
      key: 1,
      class: "assets-img",
      style: {
        "height": "60px"
      },
      src: val.srcOutUrl,
      controls: "controls"
    }, null, 8, _hoisted_3)) : _createCommentVNode("", true), val.srcTyp === '3' ? (_openBlock(), _createElementBlock("video", {
      key: 2,
      class: "assets-img",
      src: val.srcOutUrl,
      muted: "",
      controls: "controls"
    }, " 不支持 HTML5 video 。 ", 8, _hoisted_4)) : _createCommentVNode("", true), val.srcTyp === '7' ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(val.content), 1)) : _createCommentVNode("", true), _createElementVNode("div", null, [_cache[2] || (_cache[2] = _createElementVNode("span", null, "活动名称：", -1)), _createTextVNode(_toDisplayString(val.actName), 1)]), _createElementVNode("div", null, [_cache[3] || (_cache[3] = _createElementVNode("span", null, "投放开始时间：", -1)), _createTextVNode(_toDisplayString(val.bgnDate), 1)]), _createElementVNode("div", null, [_cache[4] || (_cache[4] = _createElementVNode("span", null, "投放结束时间：", -1)), _createTextVNode(_toDisplayString(val.endDate), 1)]), _createElementVNode("div", null, [_cache[5] || (_cache[5] = _createElementVNode("span", null, "是否必须投放：", -1)), val.mustPut === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_6, "是")) : _createCommentVNode("", true), val.mustPut === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_7, "否")) : _createCommentVNode("", true)])]);
  }), 128))]), _createElementVNode("div", null, [_createElementVNode("div", null, [_createVNode(_component_Form, null, {
    default: _withCtx(() => [_createVNode(_component_cell_group, {
      inset: ""
    }, {
      default: _withCtx(() => [_cache[9] || (_cache[9] = _createElementVNode("div", {
        class: "label"
      }, "是否按标准投放：", -1)), _createVNode(_component_RadioGroup, {
        modelValue: _ctx.formData.qualified,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.formData.qualified = $event),
        direction: "horizontal"
      }, {
        default: _withCtx(() => [_createVNode(_component_Radio, {
          name: 1
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("是", -1)]))]),
          _: 1
        }), _createVNode(_component_Radio, {
          name: 0
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("否", -1)]))]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_8, [_cache[8] || (_cache[8] = _createTextVNode("备注：", -1)), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.formData.remark = $event)
      }, null, 512), [[_vModelText, _ctx.formData.remark]])])]),
      _: 1
    }), _createElementVNode("div", _hoisted_9, [_createVNode(_component_Button, {
      type: "primary",
      size: "small",
      color: "#e89015",
      "native-type": "submit",
      onClick: $setup.onSubmit
    }, {
      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("确认提交", -1)]))]),
      _: 1
    }, 8, ["onClick"])])]),
    _: 1
  })])])]);
}